import { Form, Offcanvas } from "react-bootstrap";
import { FaPlus, FaTimes } from "react-icons/fa";

const AddNewRequest = ({ Show, Hide }) => {
  // --- Static data ---
  const REQUEST_TYPES = [
    "New Access",
    "Additional Access",
    "Modify Access",
    "Deactivate Access",
  ];
  const APPLICATIONS = [
    "EDC",
    "IWRS/RTSM",
    "eTMF",
    "Safety Database",
    "CDISC/Programming Portal",
    "LUP (Lab Upload Portal)",
    "Training Management System",
  ];
  const ROLES = [
    "Investigator (PI)",
    "Sub-Investigator",
    "CRC",
    "CRA/Monitor",
    "Data Manager",
    "Medical Monitor",
    "Safety Reviewer",
    "Biostatistician",
    "Statistical Programmer",
    "Site Pharmacist",
    "Lab User",
    "Sponsor Read-Only",
    "Auditor",
    "Admin",
  ];

  return (
    <Offcanvas
      show={Show}
      onHide={Hide}
      placement="end"
      style={{ width: "480px" }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>New access request</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        {/* --- Who needs access --- */}
        <div style={{ border: 0, padding: 0, margin: "0 0 24px" }}>
          <div
            style={{
              fontSize: 12.5,
              fontWeight: 600,
              color: "#0D7C74",
              display: "flex",
              alignItems: "center",
              gap: 9,
              width: "100%",
              marginBottom: 15,
              padding: 0,
            }}
          >
            Who needs access
            <div style={{ flex: 1, height: 1, background: "#E3E7F0" }}></div>
          </div>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Full name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              className="form-control form-control-sm"
              placeholder="e.g. Priya Nair"
              defaultValue="Dr. Ananya Rao"
              style={{ fontSize: 14 }}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Work email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="email"
              className="form-control form-control-sm"
              placeholder="name@organisation.com"
              defaultValue="ananya.rao@meridianhealth.in"
              style={{ fontSize: 14 }}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Organisation or CRO <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              className="form-control form-control-sm"
              placeholder="e.g. Atlas Clinical CRO"
              defaultValue="Meridian Health Research (Site 104)"
              style={{ fontSize: 14 }}
            />
          </Form.Group>

          <div className="mb-0">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Phone
            </Form.Label>
            <Form.Control
              type="tel"
              className="form-control form-control-sm"
              placeholder="Optional"
              defaultValue="+91 98450 11234"
              style={{ fontSize: 14 }}
            />
          </div>
        </div>

        {/* --- Study and request type --- */}
        <div style={{ border: 0, padding: 0, margin: "0 0 24px" }}>
          <div
            style={{
              fontSize: 12.5,
              fontWeight: 600,
              color: "#0D7C74",
              display: "flex",
              alignItems: "center",
              gap: 9,
              width: "100%",
              marginBottom: 15,
              padding: 0,
            }}
          >
            Study and request type
            <div style={{ flex: 1, height: 1, background: "#E3E7F0" }}></div>
          </div>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Request type <span className="text-danger">*</span>
            </Form.Label>
            <select
              className="form-select form-select-sm"
              defaultValue="New Access"
            >
              {REQUEST_TYPES.map((t) => (
                <option key={t}>{t}</option>
              ))}
            </select>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Study ID <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              className="form-control form-control-sm"
              placeholder="e.g. GBX-2201"
              defaultValue="GBX-2201"
              style={{ fontSize: 14 }}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Study name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              className="form-control form-control-sm"
              placeholder="Protocol title"
              defaultValue="Phase III Ustekinumab in Moderate Crohn's Disease"
              style={{ fontSize: 14 }}
            />
          </Form.Group>

          <div className="mb-0">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Sponsor <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              className="form-control form-control-sm"
              placeholder="e.g. Northwind Therapeutics"
              defaultValue="Northwind Therapeutics"
              style={{ fontSize: 14 }}
            />
          </div>
        </div>

        {/* --- Applications and role --- */}
        <div style={{ border: 0, padding: 0, margin: "0 0 24px" }}>
          <div
            style={{
              fontSize: 12.5,
              fontWeight: 600,
              color: "#0D7C74",
              display: "flex",
              alignItems: "center",
              gap: 9,
              width: "100%",
              marginBottom: 15,
              padding: 0,
            }}
          >
            Applications and role
            <div style={{ flex: 1, height: 1, background: "#E3E7F0" }}></div>
          </div>

          {APPLICATIONS.map((app, index) => (
            <div
              key={app}
              style={{
                border: "1px solid #E3E7F0",
                borderRadius: 6,
                padding: "11px 13px",
                marginBottom: 8,
                background: index < 2 ? "#EEF0FE" : "#FAFBFD",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <Form.Check
                  type="checkbox"
                  id={`app-${index}`}
                  defaultChecked={index < 2}
                  style={{ marginRight: 8 }}
                />
                <label
                  htmlFor={`app-${index}`}
                  style={{ fontWeight: 500, flex: 1, fontSize: 14 }}
                >
                  {app}
                </label>
              </div>
              {index < 2 && (
                <div
                  style={{
                    marginTop: 10,
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    flexWrap: "wrap",
                  }}
                >
                  <span
                    style={{ color: "#5B6478", marginRight: 8, fontSize: 13 }}
                  >
                    Role in this application
                  </span>
                  <select
                    className="form-select form-select-sm"
                    defaultValue={
                      index === 0 ? "Investigator (PI)" : "Investigator (PI)"
                    }
                    style={{ minWidth: 200 }}
                  >
                    <option value="">Select a role…</option>
                    {ROLES.map((r) => (
                      <option key={r}>{r}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          ))}

          <div className="mt-2">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Site number and name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              className="form-control form-control-sm"
              placeholder="e.g. 104 — Meridian Health, Bengaluru"
              defaultValue="104 — Meridian Health, Bengaluru"
              style={{ fontSize: 14 }}
            />
            <Form.Text style={{ fontSize: 12.5, color: "#8A93A6", marginTop: 2 }}>
              A site-level role is selected, so this is required.
            </Form.Text>
          </div>
        </div>

        {/* --- Access period and justification --- */}
        <div style={{ border: 0, padding: 0, margin: 0 }}>
          <div
            style={{
              fontSize: 12.5,
              fontWeight: 600,
              color: "#0D7C74",
              display: "flex",
              alignItems: "center",
              gap: 9,
              width: "100%",
              marginBottom: 15,
              padding: 0,
            }}
          >
            Access period and justification
            <div style={{ flex: 1, height: 1, background: "#E3E7F0" }}></div>
          </div>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Access start date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              className="form-control form-control-sm"
              defaultValue="2026-09-01"
              style={{ fontSize: 14 }}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Access end date
            </Form.Label>
            <Form.Control
              type="date"
              className="form-control form-control-sm"
              style={{ fontSize: 14 }}
            />
            <Form.Text style={{ fontSize: 12.5, color: "#8A93A6", marginTop: 2 }}>
              Leave blank for access lasting until study close-out.
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13.5 }}>
              Justification and comments
            </Form.Label>
            <textarea
              className="form-control form-control-sm"
              rows={3}
              placeholder="Why this access is needed — study role, delegation, and anything the access manager should know."
              defaultValue="Principal Investigator for Site 104. Site initiation visit completed; needs eCRF entry and query response access from first-patient-in."
              style={{ fontSize: 14, resize: "vertical" }}
            />
          </Form.Group>

          <div className="mb-0">
            <div
              style={{
                display: "flex",
                gap: 10,
                padding: "13px 14px",
                border: "1px solid #E3E7F0",
                borderRadius: 6,
                background: "#FAFBFD",
              }}
            >
              <Form.Check type="checkbox" defaultChecked style={{ marginTop: 3 }} />
              <div>
                <label style={{ fontWeight: 500, fontSize: 14 }}>
                  Required training is complete{" "}
                  <span className="text-danger">*</span>
                </label>
                <div style={{ fontSize: 12.5, color: "#8A93A6" }}>
                  Protocol, GCP, and system training must be recorded in the
                  Training Management System before access is granted.
                </div>
              </div>
            </div>
          </div>
        </div>
      </Offcanvas.Body>

      {/* --- Footer Actions --- */}
      <div className="text-end p-2 border-top d-flex gap-2 justify-content-end">
        <button className="removeProfile">
          <FaTimes className="me-1" /> Clear All
        </button>
        <button className="updateProfile">
          <FaPlus className="me-1" /> Add Request
        </button>
      </div>
    </Offcanvas>
  );
};

export default AddNewRequest;
